module.exports = __webpack_public_path__ + "static/media/check_circle.625d1d37.svg";